import { render, staticRenderFns } from "./Filestack.vue?vue&type=template&id=36264368&"
import script from "./Filestack.vue?vue&type=script&lang=js&"
export * from "./Filestack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports